<template>
	<div ref="rowWrapper" class="row">
		<div :class="[columnClasses.wide]">
			<transition name="reveal-from-left">
				<overlay-link 
				v-if="data.image" 
				ref="animationTarget" 
				:model="data.model" 
				:image="data.image" 
				:index="'video-' + slug" 
				:class="['swipe-in-target', { reveal: reveal }]"></overlay-link>
			</transition>
		</div>
	</div>
</template>


<script>
import BaseMediaBlock from './BaseMediaBlock'
export default {
	extends: BaseMediaBlock,
	props: ['data', 'visible', 'columnClasses'],
	computed: {
		slug() {
			if (typeof this.data.src === 'undefined') return '';
			var parts = this.data.src.split('/')
			return parts[parts.length-1];
		}
	},
	components: {
		OverlayLink: () => import('../../../../components/global/OverlayLinkAndContent')
	}
}
</script>